import { fetcher } from "helpers/fetcher";

import { TAddCorpMemberReq, TAddCorpMemberRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const addCorpMember = async (payload: TAddCorpMemberReq) => {
  return await fetcher<TAddCorpMemberRes, TAddCorpMemberReq["data"]>(
    ENDPOINT.CORPORATION.ADD_CORP_MEMBER,
    {
      data: payload.data,
      headers: {
        [API_HEADER.CORP_ID]: payload.idCorp,
      },
    }
  );
};

export const mutationAddCorpMember = async (payload: TAddCorpMemberReq) => {
  return (await addCorpMember(payload)).data;
};

mutationAddCorpMember._key = (payload: TAddCorpMemberReq) => [
  ENDPOINT.CORPORATION.ADD_CORP_MEMBER.url,
  payload,
];
